import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';
import tvCommunicate from 'src/api/communicate/tvCommunicate';

export const LOAD_REQUEST = 'LOAD_TV_GRAPH_REQUEST';
export const LOAD_SUCCESS = 'LOAD_TV_GRAPH_SUCCESS';
export const LOAD_FAIL = 'LOAD_TV_GRAPH_FAIL';

export const SUBMIT_SUCCESS = 'SUBMIT_TV_GRAPH_SUCCESS';
export const SUBMIT_FAIL = 'SUBMIT_TV_GRAPH_FAIL';
export const SUBMIT_REQUEST = 'SUBMIT_TV_GRAPH_REQUEST';

export const DELETE_FAIL = 'DELETE_TV_GRAPH_FAIL';
export const DELETE_REQUEST = 'DELETE_TV_GRAPH_REQUEST';
export const DELETE_SUCCESS = 'DELETE_TV_GRAPH_SUCCESS';

export const UPDATE_SUCCESS = 'UPDATE_TV_GRAPH_SUCCESS';
export const UPDATE_FAIL = 'UPDATE_TV_GRAPH_FAIL';
export const UPDATE_REQUEST = 'UPDATE_TV_GRAPH_REQUEST';

export const loadTvGraphRequest = () => ({ type: LOAD_REQUEST });
export const loadTvGraphFail = (error) => ({ type: LOAD_FAIL, error });
export const loadTvGraphSuccess = (tvGraph) => ({ type: LOAD_SUCCESS, tvGraph });

const submitTvGraphRequest = (tvGraph) => ({ type: SUBMIT_REQUEST, tvGraph });
const submitTvGraphSuccess = (result) => ({ type: SUBMIT_SUCCESS, result });
const submitTvGraphFail = (error) => ({ type: SUBMIT_FAIL, error });

const deleteTVGraphRequest = (Id) => ({ type: DELETE_REQUEST, Id });
const deleteTVGraphFail = (error) => ({ type: DELETE_FAIL, error });
const deleteTVGraphSuccess = (Id) => ({ type: DELETE_SUCCESS, Id });

const updateTvGraphRequest = (tvGraph) => ({ type: UPDATE_REQUEST, tvGraph });
const updateTvGraphSuccess = (result) => ({ type: UPDATE_SUCCESS, result });
const updateTvGraphFail = (error) => ({ type: UPDATE_FAIL, error });

export const loadTvGraph = (deviceId, useTvCommunicate) => (dispatch) => {
  /* Loads TV-s and all related graphs */
  dispatch(loadTvGraphRequest());
  const communicator = useTvCommunicate ? tvCommunicate.request : communicate;
  return communicator({ url: 'Graphs', method: 'get', getParams: `?deviceId=${deviceId}` })
    .then((response) => {
      dispatch(loadTvGraphSuccess(response.data.Data[0]));
    })
    .catch((err) => {
      dispatch(loadTvGraphFail(err));
      toastrError(err);
    });
};

export const deleteTvGraph = (tvId) => (dispatch) => {
  dispatch(deleteTVGraphRequest(tvId));
  return communicate({ url: 'Graphs/Lines', method: 'delete', getParams: `?id=${tvId}` })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteTVGraphSuccess(tvId));
    }).catch((err) => {
      dispatch(deleteTVGraphFail(err));
      toastrError(err);
    });
};

export const updateTvGraph = (tv) => (dispatch) => {
  dispatch(updateTvGraphRequest(tv));
  return communicate({ url: 'Graphs/Lines', method: 'put', data: tv })
    .then((response) => {
      dispatch(updateTvGraphSuccess(response.data.Data));
      toastrSuccess(response);
    }).catch((err) => {
      dispatch(updateTvGraphFail(err));
      toastrError(err);
    });
};

export const submitTvGraph = (tvGraph) => (dispatch) => {
  dispatch(submitTvGraphRequest(tvGraph));
  return communicate({ url: 'Graphs/lines', method: 'post', data: tvGraph })
    .then((response) => {
      dispatch(submitTvGraphSuccess(response.data.Data));
      toastrSuccess(response);
    }).catch((err) => {
      toastrError(err);
      dispatch(submitTvGraphFail(err));
    });
};
